<ng-container *ngIf="speaker">
  <app-modal-shell>
    <app-modal-body>
      <app-speaker [speaker]="speaker"></app-speaker>
    </app-modal-body>
    <app-modal-footer>
      <app-button (clickEmitter)="close()" text="OK"></app-button>
    </app-modal-footer>
  </app-modal-shell>
</ng-container>
